import React from "react";
import { SvgIcon } from "@mui/material";
function IltIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="M5.5 22V14.5H4V9C4 7.9 4.9 7 6 7H10C11.1 7 12 7.9 12 9V14.5H10.5V22H5.5ZM8 6C9.11 6 10 5.11 10 4C10 2.89 9.11 2 8 2C6.89 2 6 2.89 6 4C6 5.11 6.89 6 8 6Z" />
          <rect
            x="18.5664"
            y="3.41992"
            width="2.00291"
            height="9.22083"
            transform="rotate(30 18.5664 3.41992)"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default IltIcon;
